import Chip from "@material-ui/core/Chip";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { Button, Card, Checkbox, FormControlLabel, FormGroup, Stack, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import JoditEditor from "jodit-react";
import moment from "moment";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../config/authaxios";
import Body from "../../ui/Body";
import CountrySelect from "../../ui/CountrySelect";




function Create() {
  const search = useLocation().search;
  const navigate = useNavigate()
  const couponId = new URLSearchParams(search).get("couponId");



  let inputObj = {
    name: "",
    image: "",
    description: "",
    price: [],
    expiry: "",
    how_to_use_desc:"",
    how_to_use_points :[],
    outer_color :[],
    detail_colors:"",
    small:"",
    c_percentage:"",
    partner_link:"",
    redeem_method: [],
    note: "",
    country: "",
  }

  const [coupons, setCoupons] = useState(inputObj);
  // const {name,image,description,price}=coupons
  const [priceArray, setPriceArray] = useState([]);
  const [priceInput, setPriceInput] = useState("");
  const [pointArray, setPointArray] = useState([]);
  const [pointInput, setPointInput] = useState("");
  const [detailColorArray, setDetailColorArray] = useState(["#000","#000","#000"]);
  // detailColorArray
  const [expiry, setExpiry] = useState();
  const [imageUpload, setImageUploaded] = useState('')
  const [smallImageUpload, setSmallImageUploaded] = useState('')

  const handlefileInput = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    const Dataform = new FormData();
    Dataform.append("file", file);
    let FileSize = Number(file.size / 1000);
    var _URL = window.URL || window.webkitURL;
    let img = new Image();
    var width, height;
    img.onload = function () {
      // //console.log(img, file);
      width = this.width;
      height = this.height;
      // if (FileSize > 5000) {
      //     return alert(`Image should be to under 50kb reupload image, Your file size is ${FileSize}`)
      // }
      // if (height <= 250 && height > 150 && width <= 1352 && width > 450) {
      //console.log(Dataform);
      axios
        .post(`/admin/upload-image`, Dataform)
        .then((res) => {
          const url = res?.data?.Image?.url;
          if (!url) {
            console.error("Unexpected upload response shape:", res?.data);
            alert("Image upload failed: server did not return an image URL.");
            return;
          }

          console.log(e.target.id, "id");
          if (e.target.id === "image") {
            setCoupons((prev) => ({ ...prev, image: url }));
            setImageUploaded(url);
          } else {
            setCoupons((prev) => ({ ...prev, small: url }));
            setSmallImageUploaded(url);
          }

          alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
        })
        .catch((err) => {
          console.error("Upload failed:", err?.response?.data ?? err);
          alert(err?.response?.data?.message ?? "Image upload failed.");
        });
      // } else {
      //   alert(
      //     `Image height less then 250 & greater then 150 width less then 1352 & greater then 450, Your height=${height} & width=${width}`
      //   );
      // }
    };
    img.onerror = function () {
      alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
  };
  const onChangeHandler = (e) => {
    console.log(e.target.value,"value")
    setCoupons({ ...coupons, [e.target.id]: e.target.value })
  };

  const onToggleRedeemMethod = (value) => (e) => {
    const checked = e.target.checked;
    setCoupons((prev) => {
      const current = Array.isArray(prev.redeem_method) ? prev.redeem_method : [];
      if (checked) return { ...prev, redeem_method: Array.from(new Set([...current, value])) };
      return { ...prev, redeem_method: current.filter((v) => v !== value) };
    });
  };

  const AddPriceInArray = () => {
    let temp = priceArray;
    //console.log("priceinput-->",priceInput)
    temp.push(...priceInput);
    //console.log("temp-->",temp)
    setPriceArray(temp);
    setPriceInput("");
  };

  const handleDeleteRule = (index) => {
    let temp = priceArray;
    temp.splice(index, 1);
    setPriceArray([...temp]);
  };


  const AddPointInArray = () => {
    let temp = pointArray;
    temp.push(...pointInput);
    setPointArray(temp);
    setPointInput("");
  };

  const handleDeletePoint = (index) => {
    let temp = pointArray;
    temp.splice(index, 1);
    setPointArray([...temp]);
  };


  const closeHandler = () => {
    const colorPicker = document.getElementById("outercolor");

    // Close color picker after selecting a color
    colorPicker.addEventListener("input", () => {
      colorPicker.blur(); // Close the color picker
    });
  };



  const onChangeHandlerColor = (index, newColor) => {
    const updatedColors = [...detailColorArray];
    updatedColors[index] = newColor;
    setDetailColorArray(updatedColors);
    console.log(detailColorArray);
  };

  const updateHandler = () => {
    if (!coupons.country) {
      return alert("Please select a country");
    }
    let obj = {}
    obj._id = couponId
    obj.name = coupons.name
    obj.outer_color = coupons.outer_color
    obj.partner_link = coupons.partner_link 
    obj.c_percentage = coupons.c_percentage
    obj.image = coupons.image
    obj.small = coupons.smallImageUpload
    obj.description = coupons.description
    obj.price = priceArray
    obj.expiry = moment(expiry).format('YYYY-MM-DD[T00:00:00.000Z]')
    obj.how_to_use_desc=coupons.how_to_use_desc
    obj.how_to_use_points =pointArray
    obj.detail_colors = detailColorArray;
    obj.redeem_method = (Array.isArray(coupons.redeem_method) ? coupons.redeem_method : []).map(Number);
    obj.note = coupons.note ? String(coupons.note) : null;
    obj.country = coupons.country;

    //console.log("obj-->",obj)
    axios.post(`/admin/create-coupon`, obj).then((res) => {
      //console.log(res);
      // let data = res.data.response;
      alert(res.data.message)
      navigate('/getallcoupon')


    });
  }

  console.log("imageUpload", imageUpload)

  return (
    <>
      <Body>
        <Card sx={{ p: 4 }}>
          <Stack spacing={2}>
            <section>
              <section>
                <Typography> Name :</Typography>
                <TextField
                  fullWidth
                  type="text"
                  className="rounded  py-2"
                  id="name"
                  value={coupons.name}
                  onChange={onChangeHandler}
                // placeholder="Enter App version"
                />
              </section>
              <section>
                <Typography>Description :</Typography>
                {/* <textarea rows="10"
                type="text"
                className="rounded  py-2"
                id="description"
                value={coupons.description}
                onChange={onChangeHandler}
              /> */}
                <JoditEditor

                  tabIndex={5}
                  id="description"
                  value={coupons.description}
                  onBlur={(e) => { setCoupons({ ...coupons, description: e }) }}
                  onChange={(e) => { setCoupons({ ...coupons, description: e }) }}
                />

              </section>
              <Box sx={{ my: 2 }}>
                <label htmlFor="image">
                  <input
                    accept="image/*"
                    id="image"
                    type="file"
                    onChange={handlefileInput}
                    style={{ display: 'none' }}
                  />
                  <Button
                    variant="contained"
                    component="span"
                    endIcon={<DriveFolderUploadIcon />}
                    color="info"
                  >
                    Upload Image
                  </Button>
                </label>


              </Box>
              {imageUpload && <img src={imageUpload} width='100' alt='image_uploaded' />}

              <Box sx={{ my: 2 }}>
                <label htmlFor="small_img">
                  <input
                    accept="image/*"
                    id="small_img"
                    type="file"
                    onChange={handlefileInput}
                    style={{ display: 'none' }}
                  />
                  <Button
                    variant="contained"
                    component="span"
                    endIcon={<DriveFolderUploadIcon />}
                    color="info"
                  >
                    Upload small Image
                  </Button>
                </label>


              </Box>
              {smallImageUpload && <img src={smallImageUpload} width='100' alt='image_uploaded' />}
            </section>
            <section>
              <section>
                <Typography>Country :</Typography>
                <CountrySelect
                  value={coupons.country}
                  onChange={(countryId) =>
                    setCoupons({ ...coupons, country: countryId })
                  }
                  required
                />
              </section>
              <section>
                <Typography> Expiry :</Typography>
                {/* {console.log("expiry", expiry)} */}
                <TextField
                  fullWidth
                  type="datetime-local"
                  className="rounded  py-2"
                  id="expiry"
                  value={expiry}
                  onChange={(e) => { setExpiry(e.target.value) }}
                />
              </section>
              <Stack spacing={1}>
                <Typography> Price :</Typography>
                <TextField
                  fullWidth
                  type="number"
                  className="rounded  py-2"
                  onKeyDown={(evt) => ["e", "E", "+", "-", " "].includes(evt.key) && evt.preventDefault()}
                  id="price"
                  value={priceInput}
                  onChange={(e) => { e.target.value > 0 ? setPriceInput([e.target.value]) : setPriceInput() }}
                />
                <Box>
                  <Button
                    variant="contained"
                    color='info'
                    disabled={priceInput ? false : true}
                    onClick={AddPriceInArray}>
                    {priceInput ? "Add Price" : "Enter Price"}
                  </Button>
                </Box>
              </Stack>
              <section>
                {priceArray.length > 0 &&
                  priceArray.map((item, index) => {
                    return (
                      <Chip
                        key={index}
                        onDelete={() => {
                          handleDeleteRule(index);
                        }}
                        label={item}
                      />
                    );
                  })}
              </section>

              <section>
                <Typography> Partner Link :</Typography>
                <TextField
                  fullWidth
                  type="text"
                  className="rounded  py-2"
                  id="partner_link"
                  value={coupons.partner_link}
                  onChange={onChangeHandler}
                // placeholder="Enter App version"
                />
              </section>


              <section>
                <Typography> Percentage :</Typography>
                <TextField
                  fullWidth
                  type="text"
                  className="rounded  py-2"
                  id="c_percentage"
                  value={coupons.c_percentage}
                  onChange={onChangeHandler}
                // placeholder="Enter App version"
                />
              </section>

              <section>
                <Typography>Redeem Method :</Typography>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={(coupons.redeem_method || []).includes(1)}
                        onChange={onToggleRedeemMethod(1)}
                      />
                    }
                    label="Online"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={(coupons.redeem_method || []).includes(2)}
                        onChange={onToggleRedeemMethod(2)}
                      />
                    }
                    label="Offline"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={(coupons.redeem_method || []).includes(3)}
                        onChange={onToggleRedeemMethod(3)}
                      />
                    }
                    label="Combine"
                  />
                </FormGroup>
              </section>

              <section>
                <Typography> Note :</Typography>
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  id="note"
                  value={coupons.note}
                  onChange={onChangeHandler}
                />
              </section>


              <section>
                <Typography>How to use Description :</Typography>
              
                <JoditEditor

                  tabIndex={5}
                  id="how_to_use_desc"
                  value={coupons.how_to_use_desc}
                  onBlur={(e) => { setCoupons({ ...coupons, how_to_use_desc: e }) }}
                  onChange={(e) => { setCoupons({ ...coupons, how_to_use_desc: e }) }}
                />

              </section>


              <Stack spacing={1}>
                <Typography> How to use points :</Typography>
                <TextField
                  fullWidth
                  type="text"
                  className="rounded  py-2"
                  // onKeyDown={(evt) => ["e", "E", "+", "-", " "].includes(evt.key) && evt.preventDefault()}
                  id="price"
                  value={pointInput}
                  onChange={(e) => { setPointInput([e.target.value])}}
                />
                <Box>
                  <Button
                    variant="contained"
                    color='info'
                    disabled={pointInput ? false : true}
                    onClick={AddPointInArray}>
                    {pointInput ? "Add Point" : "Enter Point"}
                  </Button>
                </Box>
              </Stack>
              <section>
                {pointArray.length > 0 &&
                  pointArray.map((item, index) => {
                    return (
                      <Chip
                        key={index}
                        onDelete={() => {
                          handleDeletePoint(index);
                        }}
                        label={item}
                      />
                    );
                  })}
              </section>


              <section>
              <Typography> Outer Color :</Typography>
              <TextField
                type="color"
                className="rounded  py-2"
                style={{ width: "100px" }}
                id="outer_color"
                // value={coupons.color}
                onChange={onChangeHandler}
                
                onClick={closeHandler}
                // placeholder="Enter App version"
              />
            </section>


            <section style={{ display: "flex",flexDirection:"column" }}>
              <Typography> Detail color :</Typography>
             
              <div>
              {detailColorArray.map((color, index) => (
                <TextField
                  key={index}
                  type="color"
                  className="rounded py-2"
                  id={`detail_color${index}`}
                  // value={color}
                  value={color}
                  onChange={(e) => onChangeHandlerColor(index, e.target.value)}
                  style={{ width: "100px", margin: "10px" }}
                />
              ))}
              </div>
            </section>




            </section>
            <Box><Button variant="contained" sx={{ mt: 1 }} onClick={updateHandler}>Create</Button></Box>
          </Stack>
        </Card>
      </Body>
    </>
  );
}

export default Create;
